<div class="login-error">
  <i class="material-symbols-outlined"> error_outline </i>
  <p>{{ message() }}</p>
</div>
